import { render, staticRenderFns } from "./cuentas.vue?vue&type=template&id=a221cbbe&scoped=true&"
import script from "./cuentas.vue?vue&type=script&lang=js&"
export * from "./cuentas.vue?vue&type=script&lang=js&"
import style0 from "./cuentas.vue?vue&type=style&index=0&id=a221cbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a221cbbe",
  null
  
)

export default component.exports